import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-image-overlay',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './image-overlay.component.html',
  styleUrls: ['./image-overlay.component.scss']
})
export class ImageOverlayComponent {
  @Input() imageUrl: SafeUrl = '';
  @Output() close = new EventEmitter<void>();

  // Listen for escape key press to close the overlay
  @HostListener('document:keydown.escape', ['$event']) 
  onKeydownHandler(event: KeyboardEvent) {
    this.closeOverlay();
  }

  constructor() { }

  closeOverlay(): void {
    this.close.emit();
  }
}
